var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorImageIconUniversal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.36 9.18C18.36 14.25 14.25 18.36 9.18 18.36C4.11002 18.36 0 14.25 0 9.18C0 4.11002 4.11002 0 9.18 0C14.25 0 18.36 4.11002 18.36 9.18ZM10.3275 4.59C10.3275 5.22374 9.81376 5.7375 9.18 5.7375C8.54626 5.7375 8.0325 5.22374 8.0325 4.59C8.0325 3.95626 8.54626 3.4425 9.18 3.4425C9.81376 3.4425 10.3275 3.95626 10.3275 4.59ZM8.0325 8.0325C7.39876 8.0325 6.885 8.54626 6.885 9.18C6.885 9.81376 7.39876 10.3275 8.0325 10.3275V13.77C8.0325 14.4038 8.54626 14.9175 9.18 14.9175H10.3275C10.9613 14.9175 11.475 14.4038 11.475 13.77C11.475 13.1362 10.9613 12.6225 10.3275 12.6225V9.18C10.3275 8.54626 9.81376 8.0325 9.18 8.0325H8.0325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImageIconUniversal);
export default __webpack_public_path__ + "static/media/ErrorImageIconUniversal.87e67cf1a7633c3344818116affff6c6.svg";
export { ForwardRef as ReactComponent };